import { render } from "./AuthenticationSettingView.vue?vue&type=template&id=72ec7fcd"
import script from "./AuthenticationSettingView.vue?vue&type=script&lang=js"
export * from "./AuthenticationSettingView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__